// @flow

import { connect } from "react-redux";
import React from "react";

import Templates from "./Templates";
import { openFormModal, closeFormModal } from "src/actions/forms";
import { getInstanceFilterId } from "src/reducers";

import type { AppState } from "src/types";

type Props = {
  _openFormModal: Function,
  _closeFormModal: Function,
  formModal: boolean,
};

const Forms = ({ _openFormModal, _closeFormModal, formModal }: Props) => {
  return (
    <Templates
      openFormModal={_openFormModal}
      closeFormModal={_closeFormModal}
      formModal={formModal}
    />
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => {
  return {
    id: getInstanceFilterId(app),
    formModal: app.form.formModal,
  };
};

export default connect(mapStateToProps, {
  _openFormModal: openFormModal,
  _closeFormModal: closeFormModal,
})(Forms);
